<template>
  <va-card class="container" style="overflow-x: auto; overflow-y: visible;">
    <p class="display-5" style="color: #5f6e78;">{{ title }}</p>

    <div class="body">
      <div class="inputSection">
        <label class="flex xs12 form-label">Name</label>
        <va-input class="flex xs12 mb-4 form-input" v-bind:class="{ hasError: nameError !== '' }" v-model="name"
          placeholder="Enter Domain name here" />
        <label v-if="nameError !== ''" class="error-label">{{ nameError }}</label>
      </div>
      <!-- 
      <div class="inputSection">
        <label class="form-label">Status</label>
        <va-checkbox class="mb-2" v-model="status"></va-checkbox>
      </div> 
      -->

      <div class="buttonContainer">
        <va-button class="btn alignleft"  color="gray" @click="cancel">Cancel</va-button>
        <va-button class="btn alignright"  color="gray" @click="save">Save</va-button>
      </div>

    </div>
  </va-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "edit-report-modal",
  props: {
    title: String,
    propsName: { type: String, default: "" },
    propsStatus: { type: Boolean, default: false }
  },
  data() {
    return {
      name: "",
      status: null
    };
  },
  created() {
    this.name = this.propsName;
    this.status = this.propsStatus ? this.propsStatus : false
  },
  computed: {
    ...mapState({
      selectedEntity: state => state.user.selectedEntity
    })
  },
  methods: {
    ...mapActions({
      addNewDomain: "admin/addNewDomain",
      deleteDomain: "admin/deleteDomainFromWhitelist",
      getDomainList: "admin/getDomainWhitelist"
    }),

    cancel() {
      this.$emit("close");
    },
    save() {
      if (this.validateInput()) {
        const param = {
          name: this.name,
          // status: this.status,
          entityid: this.selectedEntity.id || null
        };

        if (this.name) {
          param.name = this.name
          // param.status = this.status
          param.entityId = this.selectedEntity.id
          this.addNewDomain(param)
            .then(() => {

              this.$vaToast.init({ message: 'Successfully added new Domain', color: 'success' })
              if (this.selectedEntity) {
                this.getDomainList({ entityId: this.selectedEntity.id })
              }
            })
            .finally(() => { this.$emit("close"); });
        }
        else {
          console.log('error adding new domain. check validation');
        }

      }
    },
    validateInput() {
      let isValid = true;
      const nameRegex = new RegExp("^[-_ a-zA-Z.]+$");
      const idRegex = new RegExp("^[-_ a-zA-Z.]+$")

      if (this.name === '') {
        this.nameError = 'Required';
        isValid = false;
      }
      else if (!nameRegex.test(this.name)) {
        this.nameError = 'Only allow alphabet, space and dash';
        isValid = false;
      }
      else {
        this.nameError = '';
      }

      return isValid;
    }
  }
};
</script>

<style lang='scss' scoped>
.container {
  box-shadow: none !important;
  background: white !important;
  color: black !important;

  & .body {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;

    & .inputSection {
      //display: contents;

      & .readonly-input {
        padding-left: 0.75rem;
      }

      & .form-label {
        font-weight: 400;
        display: block;
        padding: 0.25rem;
      }

      & .form-input {
        border: 1px solid rgba(60, 60, 60, 0.26);
        border-radius: 4px;
        height: 1.5rem;
        max-height: 2rem;
        width: 100%;
        color: #333333;

        &.hasError {
          border-color: #d43d27;
        }
      }

      &+.inputSection {
        margin-top: 0.75rem;
      }

      & .error-label {
        font-size: 0.75rem;
        color: #d43d27;
        font-weight: bold;
        margin-left: 0.25rem;
      }
    }

    & .buttonContainer {
      margin-top: 0.75rem;
    }
  }
}

.alignright {
  float: right;
}

.alignleft {
  float: left;
}
</style>

<style lang="scss">
.va-select.hasError {
  &>.vs__dropdown-toggle {
    border-color: #d43d27;
  }
}

.va-input__content-wrapper .va-input__content__input {
  color: white !important;
}
</style>